enum MutationTypes {
  SUBSCRIBE_TO_EVENT = "es/SUBSCRIBE_TO_EVENT",
  UNSUBSCRIBE_FROM_EVENT = "es/UNSUBSCRIBE_FROM_EVENT",
}

export default MutationTypes;
